<template>
  <div class="my-4 text-center text-h6">

    <div v-if="mappedIcon" class="icon-circle main_color">
      <v-icon size="32" class="white--text">
        {{ mappedIcon }}
      </v-icon>
    </div>

    <span v-else>
      {{ field.etiqueta }}
    </span>

  </div>
</template>
<script>
import { mapIcon } from '@/utils/iconMapper'

export default {
  props: ['field'],

  computed: {
    mappedIcon() {
      return mapIcon(this.field.etiqueta)
    }
  }
}
</script>
<style scoped>
.icon-circle {
  width: 70px;
  aspect-ratio: 1 / 1; 
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
</style>